import { ConfigurationContext } from 'components/provider/OrginazationContext';
import DataTable from 'components/ui/DataTable/data-table';
import Modal from 'components/ui/Modal/modal';
import PermissionWrapper from 'components/ui/PermissionWapper';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import 'css/style.css';
import { useFormik } from 'formik';
import useToggle from 'hooks/useToggle';
import { FC, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cell } from 'react-table';
import { toast } from 'react-toastify';
import { useAssignToRoutineMutation } from 'redux/reducers/certification';
import { IRoutineDetail, useListRoutineQuery } from 'redux/reducers/routine';
import { nascsubdomain, trainingsubdomain } from 'redux/reducers/settings';
import { useCustomReportMutation } from 'redux/reducers/user';
import { ActionType } from 'utils/action.type.enum';
import download from 'utils/downloadFile';
import { ModuleCode } from 'utils/module.code.enum';
import EndandStartImage from './EndandStartImage';
import DownloadTraineeProfile from './Modal/DownloadTraineeProfile';
import PrintCertificateModal from './PrintCertificate';
import SelectTemplateForm from './SelectTemplateForm';
import DownloadTraineeAttendance from './Modal/DownloadTraineeAttendance';

interface ITOrganizationCentresTable {
  onViewClicked: (routineId: number) => void;
  onEditClicked: (routineId: number) => void;
  onDeleteClicked: (data: IRoutineDetail) => void;
  routineStatusValue: string;
  training: string;
  searchQuery: string;
}
const OrganizationCentresTable: FC<ITOrganizationCentresTable> = ({
  onViewClicked,
  onEditClicked,
  onDeleteClicked,
  routineStatusValue,
  training,
  searchQuery
}) => {
  const currentPage = localStorage.getItem('current_page');

  const [page, setPage] = useState(currentPage ? +currentPage : 1);
  const { appConfig } = useContext(ConfigurationContext);

  const [showReprotModal, setshowReprotModal] = useState<boolean>(false);
  const [routineId, setRoutineId] = useState<number | null>(null);
  const [selectedData, setSelectedData] = useState<IRoutineDetail | null>(null);
  const [pageSize, setPageSize] = useState(10);
  const [templateModal, setTemplateModal] = useToggle(false);
  const [printCertificateModal, setPrintCertificateModal] = useToggle(false);
  const [showDownloadTraineeProfileModal, setShowDownloadTraineeProfileModal] = useToggle(false);
  const [showCeremonyImageModal, setShowCeremonyImageModal] = useState<boolean>(false);
  const handleToggleCeremonyModal = () => setShowCeremonyImageModal((prev) => !prev);

  const [showAttendanceDownloadModal, setShowAttendanceDownloadModal] = useState<boolean>(false);
  const handleToggleAttendanceDownloadModal = () => setShowAttendanceDownloadModal((prev) => !prev);

  const [assignToRoutine, { isLoading: assigning }] = useAssignToRoutineMutation();
  const [customReport, { isLoading: isLoadingReport }] = useCustomReportMutation();

  useEffect(() => {
    localStorage.setItem('current_page', page.toString());
  }, [page]);

  useEffect(() => {
    if (currentPage) localStorage.removeItem('current_page');
  }, []);

  const navigate = useNavigate();

  const { data: routineData, isLoading } = useListRoutineQuery({
    page,
    pageSize,
    routineStatusValue,
    training,
    searchQuery
  });
  const closeModal = () => {
    setTemplateModal();
  };
  const initialValues = {
    certificate_template: 0,
    certificate_content: ''
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: (values) => {
      const sendValue = {
        ...values,
        certificate_routine: routineId
      };
      assignToRoutine(sendValue);
      formik.resetForm();
      setTemplateModal();
      toast.success('Successfully Assigned');
    }
  });
  const totalRows = routineData && routineData?.length > 0 ? routineData?.[0].row_total : 0;
  console.log('fsdfdsf', totalRows, routineData);

  const totalPages = Math.ceil(totalRows / pageSize);
  const canNext = page < totalPages;
  const canPrevious = page > 1;

  const columns = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (data: any) => {
        return <>{page === 1 ? data.row.index + 1 : data.row.index + (page - 1) * 10 + 1}</>;
      }
    },
    {
      Header: 'Training',
      accessor: 'training_details.training_name'
    },
    {
      Header: 'Trainee Count',
      accessor: 'trainee_count'
    },
    {
      Header: 'Batch',
      accessor: 'batch_name'
    },
    {
      Header: 'Hall',
      accessor: 'hall_details.hall_name'
    },
    {
      Header: 'Start Date',
      accessor: (row: any) => {
        if (row.start_date_bs) {
          return `${row.start_date_bs} B.S`; // Render start_date_bs if it exists
        } else if (row.start_date) {
          return `${row.start_date} A.D`;
        } else {
          return 'N/A';
        }
      }
    },
    {
      Header: 'End Date',
      accessor: (row: any) => {
        if (row.end_date_bs) {
          return `${row.end_date_bs} B.S`; // Render start_date_bs if it exists
        } else if (row.end_date) {
          return `${row.end_date} A.D`;
        } else {
          return 'N/A'; // Render "N/A" if neither key exists
        }
      }
    },
    {
      Header: '  Status',
      accessor: 'routine_status'
      // Cell: (data: any) => {
      //   return <StatusBadge status={data.row.original.routine_status} />;
      // }
    },
    {
      Header: 'Action',
      Cell: (data: Cell<IRoutineDetail & { routine_master_id: number }>) => {
        return (
          <div style={{ display: 'flex' }}>
            <PermissionWrapper
              actionType={ActionType.CAN_VIEW}
              module_code={ModuleCode.ROUTINE_MANAGEMENT}>
              <img
                className="icons"
                style={{ marginRight: '10px', height: '20px' }}
                src={require('../RoutineManagement/Images/view.png')}
                alt="icon for config"
                onClick={() => onViewClicked(data?.row.original.routine_master_id)}
              />
            </PermissionWrapper>
            <PermissionWrapper
              actionType={ActionType.CAN_UPDATE}
              module_code={ModuleCode.ROUTINE_MANAGEMENT}>
              <img
                className="icons"
                style={{ marginRight: '10px' }}
                src={require('../RoutineManagement/Images/edit.png')}
                alt="icon for c"
                onClick={() => onEditClicked(data?.row.original.routine_master_id)}
              />
            </PermissionWrapper>
            <div className="relative">
              <div className="dropdown d-flex justify-content-end">
                <a
                  href="#"
                  role="button"
                  id="dropdownMenuLink5"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i className="ri-more-2-fill"></i>
                </a>
                <ul
                  className="dropdown-menu fixed z-[10] position-absolute-important"
                  aria-labelledby="dropdownMenuLink">
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() =>
                        navigate(`/feedback/evaluation/${data?.row.original?.routine_master_id}`)
                      }>
                      <img
                        src={require('../RoutineManagement/Images/carbon_result.png')}
                        alt="icon for config"
                      />{' '}
                      Configuration
                    </a>
                  </li>
                  <li>
                    <a
                      style={{ zIndex: 1 }}
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() =>
                        navigate(
                          `/routine-management/${data?.row.original.routine_master_id}/feedback`
                        )
                      }>
                      <img src={require('../RoutineManagement/Images/fluent.png')} alt="view" />{' '}
                      View Feedback
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#inviteTraineeModal"
                      onClick={() => {
                        navigate(
                          `/routine-management/generate-report/${data?.row.original.routine_master_id}`
                        );
                      }}>
                      <img
                        src={require('../RoutineManagement/Images/chart.png')}
                        alt="chart image"
                      />{' '}
                      Generate Routine Report
                    </a>
                  </li>

                  {appConfig?.domain_name === nascsubdomain && (
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#inviteTraineeModal"
                        onClick={() => {
                          navigate(
                            `/routine-management/trainee-evaluation/${data?.row.original.routine_master_id}`
                          );
                        }}>
                        <img
                          src={require('../RoutineManagement/Images/chart.png')}
                          alt="chart image"
                        />{' '}
                        Evaluation
                      </a>
                    </li>
                  )}
                  <PermissionWrapper
                    actionType={ActionType.CAN_DELETE}
                    module_code={ModuleCode.ROUTINE_MANAGEMENT}>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#inviteTraineeModal"
                        onClick={() => onDeleteClicked(data.row.original)}>
                        <img
                          src={require('../RoutineManagement/Images/Vector.png')}
                          alt="delete"
                          style={{ marginRight: '10px' }}
                        />{' '}
                        Delete
                      </a>
                    </li>
                  </PermissionWrapper>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() => {
                        setSelectedData(data.row.original);
                        setShowDownloadTraineeProfileModal(true);
                        // download(
                        //   `reports/trainee-enrollment-export/${data.row.original.routine_master_id}/`,
                        //   'Routine.xlsx'
                        // )
                      }}>
                      <img
                        src={require('../RoutineManagement/Images/download.png')}
                        alt="view"
                        height="25px"
                        max-width="18px"
                      />{' '}
                      Download Trainee Profile
                    </a>
                  </li>

                  {/* {appConfig?.domain_name === nascsubdomain && (<li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() =>
                        download(
                          `reports/attendance-export/${data.row.original.routine_master_id}/`,
                          'Attendance.xlsx'
                        )
                      }>
                      <img
                        src={require('../RoutineManagement/Images/download.png')}
                        alt="view"
                        height="25px"
                        max-width="18px"
                      />{' '}
                      Download Trainee Attendance
                    </a>
                  </li>)} */}
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() => {
                        setSelectedData(data.row.original);

                        handleToggleAttendanceDownloadModal();
                      }}>
                      <img
                        src={require('../RoutineManagement/Images/download.png')}
                        alt="view"
                        height="25px"
                        max-width="18px"
                      />{' '}
                      Download Trainee Attendance
                    </a>
                  </li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() => {
                        setSelectedData(data.row.original);
                        setPrintCertificateModal();
                      }}>
                      <img
                        src={require('../RoutineManagement/Images/certificate.png')}
                        alt="view"
                        height="25px"
                        max-width="18px"
                        style={{ marginRight: '5px' }}
                      />{' '}
                      Print Certificate
                    </a>
                  </li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                      onClick={() => {
                        setSelectedData(data.row.original);

                        handleToggleCeremonyModal();
                      }}>
                      <img
                        src={require('../RoutineManagement/Images/report.png')}
                        alt="view"
                        height="25px"
                        max-width="18px"
                        style={{ marginRight: '5px' }}
                      />{' '}
                      Add Ceremony Image
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        );
      }
    }
  ];

  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const handleGenerate = () => {
    try {
      download(
        `reports/custom-summary?startDate=${startDate || ''}&endDate=${endDate || ''}`,
        'Report.pdf'
      );
    } catch (err: any) {
      toast.error('Failed to generate');
    }
  };
  console.log(selectedData);

  return (
    <div className="list form-check-all">
      {showAttendanceDownloadModal && (
        <DownloadTraineeAttendance
          routineId={selectedData?.routine_master_id ?? 0}
          routineDetail={selectedData}
          open={showAttendanceDownloadModal}
          toggle={() => setShowAttendanceDownloadModal(false)}
        />
      )}
      {showDownloadTraineeProfileModal && (
        <DownloadTraineeProfile
          routineId={selectedData?.routine_master_id ?? 0}
          open={showDownloadTraineeProfileModal}
          toggle={() => setShowDownloadTraineeProfileModal(false)}
        />
      )}

      {showReprotModal && (
        <Modal
          modalSize="modal-md"
          title={'Generate Report'}
          isModalOpen={showReprotModal}
          closeModal={() => {
            setshowReprotModal(!showReprotModal);
          }}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton
                title="Close"
                isLoading={false}
                onClick={() => setshowReprotModal(!showReprotModal)}
              />
              <PrimaryButton
                title={'Generate'}
                iconName="ri-add-line align-bottom me-1"
                type="button"
                onClick={() => {
                  handleGenerate();
                }}
                isLoading={isLoadingReport}
              />
            </div>
          )}>
          <div className="d-flex gap-2">
            <div>
              <label>Start Date</label>
              <input
                className="form-control"
                name="startDate"
                type="date"
                onChange={(e: any) => {
                  setStartDate(e.target.value);
                }}
                value={startDate}
              />
            </div>
            <div>
              <label>End Date</label>

              <input
                className="form-control"
                name="endDate"
                type="date"
                onChange={(e: any) => {
                  setEndDate(e.target.value);
                }}
                value={endDate}
              />
            </div>
          </div>
        </Modal>
      )}

      {showCeremonyImageModal && (
        <Modal
          modalSize="modal-xl"
          title={'Add Ceremony Image'}
          isModalOpen={showCeremonyImageModal}
          closeModal={() => {
            handleToggleCeremonyModal();
          }}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton
                title="Close"
                isLoading={false}
                onClick={() => handleToggleCeremonyModal()}
              />
              {/* <PrimaryButton
                title={'Generate'}
                iconName="ri-add-line align-bottom me-1"
                type="button"
                onClick={() => {
                  handleGenerate();
                }}
                isLoading={isLoadingReport}
              /> */}
            </div>
          )}>
          <div className="d-flex gap-2">
            <EndandStartImage
              routineInfo={selectedData}
              routineId={selectedData?.routine_master_id ?? '0'}
            />
          </div>
        </Modal>
      )}

      <DataTable
        columns={columns}
        // data={routineData?.results?.data || []}
        data={routineData ?? []}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
            if (canPrevious) {
              setPage((prev) => prev - 1);
            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
        }}
        search={false}
      />
      {printCertificateModal && (
        <PrintCertificateModal
          selectedData={selectedData}
          templateModal={printCertificateModal}
          closeModal={() => {
            setPrintCertificateModal();
          }}
        />
      )}
      <form onSubmit={formik.handleSubmit}>
        <Modal
          title={'Assign Template'}
          isModalOpen={templateModal}
          closeModal={closeModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton title="Close" isLoading={false} onClick={() => setTemplateModal()} />
              <PrimaryButton
                title={'Submit'}
                iconName="ri-add-line align-bottom me-1"
                type="submit"
                isLoading={false}
              />
            </div>
          )}>
          <SelectTemplateForm formik={formik} />
        </Modal>
      </form>
    </div>
  );
};

export default OrganizationCentresTable;
